module.exports = __webpack_public_path__ + "img/band-aid.9cb5e02d.jpg";